<div #container class="split-container" [class.collapsed]="isCollapsed" [class.collapsed-left]="showCollapsedLeft" [class.collapsed-right]="showCollapsedRight">
  <div class="left-pane" [style.flex-basis.%]="isCollapsed ? 0 : leftRatio * 100">
    <ng-content select="[left]"></ng-content>
  </div>
  <div
    #divider
    class="divider"
    role="separator"
    aria-orientation="vertical"
    tabindex="0"
    (mousedown)="onDividerMouseDown($event)"
  ></div>
  <div class="right-pane" [style.flex-basis.%]="isCollapsed ? 100 : (100 - leftRatio * 100)">
    <ng-content select="[right]"></ng-content>
  </div>

  @if (showCollapsedLeft) {
    <div class="restore-hover-zone left" aria-hidden="true"></div>
  }
  @if (showCollapsedLeft) {
    <button
      type="button"
      class="restore-tag left"
      aria-label="Restore split from left"
      (click)="restoreFromLeft()"
      >
      <i class="bi bi-chevron-right"></i>
    </button>
  }

  @if (showCollapsedRight) {
    <div class="restore-hover-zone right" aria-hidden="true"></div>
  }
  @if (showCollapsedRight) {
    <button
      type="button"
      class="restore-tag right"
      aria-label="Restore split from right"
      (click)="restoreFromRight()"
      >
      <i class="bi bi-chevron-left"></i>
    </button>
  }
</div>

